<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">公司物料</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInUserEdit">
      <section class="searchBox">
        <span>
          <label>字符串：</label>
          <div>
            <a-input
              placeholder="请输入物料名称|员工姓名|员工手机号"
              v-model="query_field"
              style="margin-right:20px;"
            />
          </div>
        </span>
        <span>
          <a-button @click="reactPage" style="margin-right:10px;"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <!-- <td></td> -->
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.user_name }}</td>
              <td>{{ item.name }}</td>
              <td>
                <p v-show="item.type == 1">工具</p>
                <p v-show="item.type == 2">消耗品</p>
              </td>
              <td>{{ item.total_in + "&nbsp;" + item.unit }}</td>
              <td style="width:30%">
                <span
                  class="areaStyle"
                  v-for="(element, j) in item.order_count_list"
                  :key="j"
                >
                  <p v-show="j > 0">&nbsp;|&nbsp;</p>
                  <label v-if="element.type == 1">开荒：</label>
                  <label v-else-if="element.type == 2">双周：</label>
                  <label v-else-if="element.type == 3">深度：</label>
                  <label v-else-if="element.type == 4">退租：</label>
                  <p>{{ element.order_count }}</p>
                </span>
                <p v-show="item.role_type == 1">all</p>
              </td>
              <td>{{ item.order_consume + "&nbsp;" + item.unit }}</td>
              <td>{{ item.guard_surplus + "&nbsp;" + item.unit }}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addAdministrator v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <administratorEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addAdministrator from "@/components/clean/addAdministrator"; //增加
import administratorEdit from "@/components/clean/administratorEdit"; //编辑

export default {
  components: {
    addAdministrator,
    administratorEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: [
        "员工姓名",
        "物料名称",
        "类型",
        "总发放",
        "工单数量",
        "预计消耗",
        "预计现存"
      ]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    reactPage() {
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Material/guardMaterialList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.areaStyle {
  p {
    display: inline-block;
  }
}
.listContainer {
  .searchBox {
    display: block;
    .addStyle {
      margin-right: 24%;
    }
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 10px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
